import Link from "next/link";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { useBudouX } from "@/hooks/useBudouX";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { Br } from "@/components/molecules/Br";
import Contact from "@/components/organisms/Contact";
import { ProductCover } from "@/components/organisms/ProductCover";
import { SpeedCmsCover } from "@/components/organisms/SpeedCmsCover";
import Careers from "@/components/organisms/Careers";
import { ProductItem } from "@/components/organisms/ProductItem";
import { ProductItemPartner } from "@/components/organisms/ProductItemPartner";
import Image from "next/image";

const products = [
  {
    src: "/thumb-HeartCore.webp",
    href: "https://www.heartcore.co.jp/products/CX/index.html",
    lead: "国内シェアNo.1 CMSパッケージ。サイトの管理・運用に必要なすべての機能を提供します。",
    title: "HeartCore",
    desc: "HeartCore CMSは、「サイト構築」「マーケティング支援」「他システム連携」の基本機能。静的なサイトからユーザーニーズに合った情報を発信できる動的なサイトへ、コンテンツを管理するシステムからコンテンツを活用するシステムです。",
  },
  {
    src: "/thumb-microCMS.webp",
    href: "https://microcms.io/",
    lead: 'あらゆるコンテンツ運用を素早く簡単に。<br class="tbpc">microCMSはAPIベースの日本製ヘッドレスCMS。',
    title: "microCMS",
    desc: "全く新しいコンテンツ管理「microCMS」。サイトやアプリのコンテンツ運用にかかる工数をビジネス価値の創出へ。柔軟な施策により、５日間かかるコンテンツの更新をたった１時間に。あなたのビジネスを加速させます。",
  },
  {
    src: "/thumb-ToccaDentalBasic.webp",
    href: "http://dental-web.net/",
    title: "TOCCA DENTAL WEB BASIC",
    desc: "トッカシステムズの300件以上の実績から、先生達の声を元に考えた最適解。歯科医院にトッカした“思い”を伝えるツール（CMS）です。",
  },
  {
    sub: [
      {
        src: "/thumb-HoikuenCMS.webp",
        href: "/hoikuencms.pdf",
        title: "保育園CMS",
        desc: "保育園にトッカしたウェブサイトを簡単構築。知識がなくても運用できる！",
      },
      {
        src: "/thumb-ShotengaiCMS.webp",
        href: "http://xn--czrs0te68a.biz/",
        title: "商店街CMS",
        desc: "知識がなくても大丈夫。商店街にトッカした機能をオールインワンに搭載！",
      },
    ],
  },
];

const partnersMail = [
  {
    src: "/thumb-ActiveGateSS.webp",
    href: "https://activegate-ss.jp/",
    title: "Active! gate SS",
    desc: "クラウド型で運用するメール誤送信防止",
  },
  {
    src: "/thumb-ActiveVaultSS.webp",
    href: "https://activevault-ss.jp/",
    title: "Active! vault SS",
    desc: "クラウド型で運用するメールアーカイブ",
  },
  {
    src: "/thumb-ActiveWorld.webp",
    href: "https://active-world.jp/",
    title: "Active! world",
    desc: "スパム・ウイルス対策完備のクラウド型メールサービス",
  },
  {
    src: "/thumb-qualitiaCloud.webp",
    href: "https://www.jp.qualitiacloud.com/",
    title: "QUALITIA CLOUD",
    desc: "デジタルワークスペースを実現するアプリケーションハブ",
  },
];

const partnersSecurity = [
  {
    src: "/thumb-blueSphere.webp",
    href: "https://bluesphere.jp/",
    title: "BLUE Sphere",
    desc: "クラウド型のWAF/DDoS防御/改ざん検知機能を備えた、総合セキュリティサービス",
  },
  {
    src: "/thumb-mamorune.webp",
    href: "https://mamorune.irob.co.jp/",
    title: "mamorune",
    desc: "データバックアップとセキュリティ対策の一体型ソリューション",
  },
];

const partnersEC = [
  {
    src: "/makeshop.png",
    href: "https://www.makeshop.jp",
    title: "makeshop",
    desc: "11年連続No.1 売れるECサイト構築ならmakeshop",
  },
];

export default function ProductPage(props) {
  const isHeaderRelative = true;
  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={"プロダクト・取扱サービス"}
        pageDescription={
          "株式会社トッカシステムズのプロダクト・取扱いサービスです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/product/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            {/* <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Product",
                },
              ]}
            /> */}
            <Inner className="max-w-full">
              <ProductCover />
              <div className="box-border px-4 pt-4 pb-12 md:px-6 md:pt-10 md:pb-20 lg:pt-14">
                <Link href="/product/onstep/" className="cursor-pointer">
                  <figure className="group relative mx-auto box-border block aspect-[1272/360] w-full max-w-6xl cursor-pointer border border-solid border-bdc-light hover:opacity-80">
                    <Image
                      src="/product-onstep.webp"
                      alt="ONSTEP - オンステップ"
                      quality={80}
                      layout="fill"
                      objectFit="cover"
                    />
                  </figure>
                </Link>
                <div className="mx-auto mb-10 box-border flex max-w-6xl flex-col items-start justify-start gap-2 pt-5 md:gap-4">
                  <h3 className="w-full font-serif font-bold text-pri fluid-text-[18px,32px]">
                    あなたのコミュニティを、より深く、もっと近くに。
                  </h3>
                  <div className="w-full font-bold leading-comfort text-txt-base fluid-text-[14px,18px] md:w-10/12">
                    ONSTEPは、ファンマーケティングの全機能を統合したプラットフォーム。
                    <Br pc />
                    会員管理からEC、コンテンツ配信まで一括提供、複数テナント対応で手数料率も自由設定。運営業務を簡素化し、ファンとの絆を深めながら収益向上を実現。多言語対応で国内外のコミュニティ構築をサポートします。
                  </div>
                </div>
                <Link href="/product/speedcms/">
                  <a className="hover:opacity-80">
                    <SpeedCmsCover className="max-w-6xl" />
                  </a>
                </Link>
                                <div className="mx-auto box-border flex max-w-6xl flex-col items-start justify-start gap-2 pt-5 md:gap-4">
                                  <h3 className="w-full font-serif font-bold text-pri fluid-text-[18px,32px]">
                                    シンプル･オールインワンの基本機能+強力な拡張性。
                                    <Br />
                                    速くて、軽くて、ちょうどいい。動作環境を問わない高速軽快高機能CMS
                                  </h3>
                                  <div className="w-full font-bold leading-comfort text-txt-base fluid-text-[14px,18px] md:w-10/12">
                                    SpeedCMSは、エンタープライズ向けCMS。ウェブサイトの運用現場で求められるコア要件を満たし、低コストでどんな環境でも軽快に動作し、お客様のビジネスに合わせ柔軟に拡張できることが強みです。中規模向けサイトを中心に、コーポレートから、情報配信、会員向けサービス、ECなど様々な導入・運用実績がございます。
                                  </div>
                                </div>
                                <Link href="/product/cloud-cms/">
                                  <a className="hover:opacity-80">
                                    <figure className="group relative mx-auto mt-10 box-border block aspect-[1272/360] w-full max-w-6xl cursor-pointer overflow-hidden rounded-lg border border-solid border-bdc-light">
                                      <Image
                                        src="/images/product/cloud-cms-banner.png"
                                        alt="クラウド型CMSサービス"
                                        quality={80}
                                        layout="fill"
                                        objectFit="cover"
                                      />
                                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40">
                                        <h2 className="text-center font-serif text-2xl font-bold text-white drop-shadow-lg md:text-4xl">
                                          クラウド型CMSサービス
                                        </h2>
                                      </div>
                                    </figure>
                                  </a>
                                </Link>
                                <div className="mx-auto box-border flex max-w-6xl flex-col items-start justify-start gap-2 pt-5 md:gap-4">
                                  <h3 className="w-full font-serif font-bold text-pri fluid-text-[18px,32px]">
                                    クラウドで簡単にWebサイトを更新。
                                    <Br />
                                    専門知識不要のヘッドレスCMS
                                  </h3>
                                  <div className="w-full font-bold leading-comfort text-txt-base fluid-text-[14px,18px] md:w-10/12">
                                    クラウド型CMSサービスは、ブラウザから簡単にWebサイトのコンテンツを更新できるヘッドレスCMSです。専門的な知識がなくても、直感的な操作でお知らせやイベント情報、画像などを自由に編集・公開できます。サーバー管理不要で、セキュリティも万全。お客様のビジネスに合わせた柔軟なカスタマイズにも対応します。
                                  </div>
                                </div>
                                <div className="mx-auto mt-6 grid max-w-6xl grid-cols-1 gap-4 md:mt-8 md:grid-cols-2 md:gap-6 lg:mt-10 lg:gap-10">
                  {products.map((product) => (
                    <ProductItem
                      key={product.id}
                      src={product.src}
                      href={product.href}
                      lead={product.lead}
                      title={product.title}
                      desc={product.desc}
                      sub={product.sub}
                      className="grid-flow-col grid-cols-1 "
                    />
                  ))}
                </div>
                <div className="mx-auto mt-6 max-w-6xl md:mt-8 lg:mt-10">
                  <h3 className="mb-4 font-bold text-ter">メール製品</h3>
                  <div className="grid grid-cols-2 gap-4 md:gap-10">
                    {partnersMail.map((product) => (
                      <ProductItemPartner
                        key={product.id}
                        href={product.href}
                        src={product.src}
                        title={product.title}
                        desc={product.desc}
                        className="grid-flow-col grid-cols-1 "
                      />
                    ))}
                  </div>
                </div>
                <div className="mx-auto mt-6 max-w-6xl md:mt-8 lg:mt-10">
                  <h3 className="mb-4 font-bold text-ter">セキュリティ製品</h3>
                  <div className="grid grid-cols-2 gap-4 md:gap-10">
                    {partnersSecurity.map((product) => (
                      <ProductItemPartner
                        key={product.id}
                        href={product.href}
                        src={product.src}
                        title={product.title}
                        desc={product.desc}
                        className="grid-flow-col grid-cols-1 "
                      />
                    ))}
                  </div>
                </div>
                <div className="mx-auto mt-6 max-w-6xl md:mt-8 lg:mt-10">
                  <h3 className="mb-4 font-bold text-ter">EC製品</h3>
                  <div className="grid grid-cols-2 gap-4 md:gap-10">
                    {partnersEC.map((product) => (
                      <ProductItemPartner
                        key={product.id}
                        href={product.href}
                        src={product.src}
                        title={product.title}
                        desc={product.desc}
                        className="grid-flow-col grid-cols-1 "
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Contact>
          ONSTEP,SpeedCMSはあなたのビジネスに役立てることができるツールです。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
